import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom';

import Header from 'components/Header';

import { loadSoundboxDistantData } from 'redux/actions';

import 'css/styles.css';
import 'css/soundbox-rendered.css';

import Paths from 'paths';

class SoundboxRendered extends Component{

    state = {
        audio: false,
        playingSound: false,
        playingSoundDuration : 1
    };

    componentDidMount() {
        if(this.props.soundboxUrls.length === 0) {
            this.props.loadSoundboxDistantData(this.props.soundbox);
        }
    }

    render() {
        if(this.props.soundbox === undefined) {
            return <Redirect to={Paths.PATH_ADMIN_SHOW_SOUNDBOXS}/>
        } else {
            let imageUrls = this.props.soundboxUrls.imagesUrls ?? [];
            let soundUrls = this.props.soundboxUrls.soundsUrls ?? [];
            return (
                <section>
                    <Header returnLink={Paths.PATH_ADMIN_SHOW_SOUNDBOXS}/>
                    <div id={'soundbox-rendered-wrapper'} className={this.state.playingSound ? ' playing' : ''}>
                        {
                            this.props.soundbox.sounds.map(sound => 
                                <div className={'soundbox-rendered-tile-wrapper'} key={sound.id}>
                                    <div 
                                        className={'soundbox-rendered-tile'+(this.state.playingSound === sound.id ? ' cell-active' : '')} 
                                        onClick={() => this.playSound(soundUrls.find(soundUrl => soundUrl.id === sound.id) ? soundUrls.find(soundUrl => soundUrl.id === sound.id).url : undefined, sound.id)} 
                                        key={sound.id}>
                                        <img src={imageUrls.find(imageUrl => imageUrl.id === sound.id) !== undefined ? imageUrls.find(imageUrl => imageUrl.id === sound.id).url : ''} alt={sound.id}></img>
                                        <div className={'soundbox-rendered-tile-title'}>{sound.title}</div>
                                        <div className={'progress'} style={{ animationDuration: this.state.playingSoundDuration+'s' }}></div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </section>
            )
        }
    }

    playSound = (sound, id) => {
        try {
            if(this.state.audio && !this.state.audio.paused && this.state.playingSound === id) {
                this.state.audio.pause();
                this.setState({ playingSound: false });
            } else {
                if(this.state.audio && !this.state.audio.paused) {
                    this.state.audio.pause();
                }
                let audio = new Audio(sound),
                    _ = this;
                audio.play();
                audio.onloadedmetadata = function() {
                    _.setState({
                        audio: audio,
                        playingSound: id,
                        playingSoundDuration: audio.duration
                    });
                };
                audio.onended = function() {
                    _.setState({ playingSound: false })
                };
            }
        } catch(e) {
            console.log(e);
        };
    }
}

const mapStateToProps = (state, ownProps) => {
    let soundboxId = ownProps.location.pathname === Paths.PATH_DEMO ? 51 : +ownProps.match.params.soundboxId,
        soundbox = state.soundboxs.find(soundbox => soundbox.id === soundboxId),
        soundboxUrls = state.soundboxsUrls.find(soundboxUrls => soundboxUrls.id === soundboxId),
        bundle = state.bundles.find(soundbox => soundbox.id === soundboxId);
    return {
        soundbox: soundbox,
        soundboxUrls: soundboxUrls ? soundboxUrls : [],
        bundle: bundle,
    }
};

const mapDispatchToProps = { loadSoundboxDistantData };

export default connect(mapStateToProps, mapDispatchToProps)(SoundboxRendered);
